import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { ContainsValidDynamicContentDirective, Validator } from '@vendasta/shared';
import { Subscription } from 'rxjs';
import { DynamicComponentSelectorModule } from '../../components/dynamic-component-selector';

import { EmailPreviewRefreshService } from '../../services/email-preview-refresh.service';

// Interface
export interface ButtonBlock {
  buttonText: string;
  buttonStyle: 'solid' | 'outline';
  link: string;
  buttonColor: string;
  showBackupLink: boolean;
}

// Default blank value
export const blankButtonBlock: ButtonBlock = {
  buttonText: null,
  buttonStyle: 'solid',
  link: null,
  buttonColor: '#47b75d',
  showBackupLink: false,
};

@Component({
  selector: 'email-button-block',
  templateUrl: './button-block.component.html',
  styleUrls: ['./button-block.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonToggleModule,
    MatInputModule,
    TranslateModule,
    GalaxyFormFieldModule,
    DynamicComponentSelectorModule,
    ContainsValidDynamicContentDirective,
  ],
})
export class ButtonBlockComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class') class = 'email-button-block';
  @Input() content: ButtonBlock;
  @Output() isBlockValid = new EventEmitter<boolean>();
  @ViewChild('blockInputs') blockInputs: NgForm;

  public urlMailtoOrDynamicContentRegex = Validator.URL_MAILTO_OR_DYNAMIC_CONTENT_REGEX;
  public hexColorRegex = Validator.HEX_COLOR_REGEX;

  private readonly subscriptions: Subscription[] = [];

  constructor(private emailPreview: EmailPreviewRefreshService) {}

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.blockInputs.statusChanges.subscribe((status) => {
        this.isBlockValid.emit(status === 'VALID');
      }),
    );

    this.subscriptions.push(
      this.blockInputs.valueChanges.subscribe(() => {
        this.emailPreview.refresh();
      }),
    );
  }

  trimWhitespace(link: string): void {
    this.content.link = link?.trim()?.replace(/^[\u200B-\u200D\uFEFF]+|[\u200B-\u200D\uFEFF]+$/g, '');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
